/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';
import { button as icon } from '@wordpress/icons';


/**
 * Internal dependencies
 */
import edit from './edit';
import metadata from './block.json';
import save from './save';
import { registerBlockType } from '@wordpress/blocks';

import './style.scss';

const { name } = metadata;

export { metadata, name };

registerBlockType(
	'rentsyst/vehicle-reservation-button',
	{
		icon,
		example: {
			innerBlocks: [
				{
					name: 'core/button',
					attributes: { text: __( 'Find out more' ) },
				},
				{
					name: 'core/button',
					attributes: { text: __( 'Contact us' ) },
				},
			],
		},
		edit,
		save,
	}
);
